import { StaticQuery, withPrefix, graphql } from 'gatsby';
import React from 'react';
import Helmet from 'react-helmet';
import colors from './colors';
import { siteName, siteDescription, siteKeywords } from './metas';

const SEO = ({
  title,
  description,
  color,
  shareImageURI: customShareImageURI,
  noIndex,
  location,
  pageStructuredData
}) => {
  return (
    <StaticQuery
      query={graphql`
        {
          site {
            siteMetadata {
              shareImageURI
              shareImageDescription
              shareImageWidth
              shareImageHeight
              siteUrl
            }
          }
        }
      `}
      render={data => {
        const {
          shareImageURI: defaultShareImageURI,
          shareImageWidth,
          shareImageHeight,
          shareImageDescription,
          siteUrl
        } = data.site.siteMetadata;

        const locationWithTrailingSlash = location.endsWith('/') ? location : `${location}/`;
        const canonicalURL = `${siteUrl}${locationWithTrailingSlash}`;

        const baseStructuredDataJSON = {
          '@context': `http://schema.org`
        };

        const publisherData = {
          publisher: {
            '@type': 'Organization',
            name: siteName,
            logo: {
              '@type': 'ImageObject',
              url: `${siteUrl}/android-chrome-192x192.png`
            }
          }
        };

        let structuredData = {
          ...baseStructuredDataJSON,
          ...pageStructuredData
        };

        const isArticlePage = structuredData[`@type`] === 'NewsArticle';

        if (isArticlePage) {
          structuredData = {
            ...structuredData,
            ...publisherData,
            url: canonicalURL
          };
        }

        return (
          <Helmet
            htmlAttributes={{lang: `en`}}
          >
            <title>{title || siteName}</title>
            <link rel="canonical" href={canonicalURL} />
            <meta property="og:title" content={title || siteName} />
            <meta name="keywords" content={siteKeywords && siteKeywords.join(',')} />
            <meta name="theme-color" content={color || colors.primary} />
            <meta name="description" content={description || siteDescription} />
            <meta property="og:description" content={description || siteDescription} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description || siteDescription} />
            <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            <meta name="og:type" content={isArticlePage ? 'article' : 'website'} />
            {noIndex && <meta name="robots" content="noindex" />}
            <link
              rel="apple-touch-icon"
              sizes="180x180"
              href={withPrefix('/apple-touch-icon.png')}
            />
            <link
              rel="icon"
              type="image/png"
              sizes="32x32"
              href={withPrefix('/favicon-32x32.png')}
            />
            <link
              rel="icon"
              type="image/png"
              sizes="16x16"
              href={withPrefix('/favicon-16x16.png')}
            />
            <link rel="icon" href={withPrefix('/favicon.ico')} />
            <link rel="manifest" href="/site.webmanifest" />
            <meta name="theme-color" content={colors.primary} />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:image" content={customShareImageURI || defaultShareImageURI} />
            {!customShareImageURI && shareImageWidth && (
              <meta property="og:image:width" content={shareImageWidth} />
            )}
            {!customShareImageURI && shareImageHeight && (
              <meta property="og:image:height" content={shareImageHeight} />
            )}
            <meta property="og:image:alt" content={shareImageDescription} />
            <meta property="fb:app_id" content="768947116853307" />
          </Helmet>
        );
      }}
    />
  );
};

export default SEO;
